import { useSuspenseQuery } from '@tanstack/react-query';
import { tariffSummaryGraphsQueries } from '../queries/tariffSummaryGraphsQueries';
import { getTariffSummaryCumulativeUsage } from '../api/tariffSummaryGraphsApi';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { mapUsageDTOtoAreaChartData } from 'src/common/utils/mapUsageDTOtoAreaChartData';
import { useTranslation } from 'react-i18next';

type UseTariffSummaryCumulativeUsageDataProps = {
  accountRef: string;
  tariffCode: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
};

type MappedUsageData = ReturnType<typeof mapUsageDTOtoAreaChartData>;

export const useTariffSummaryUsageData = ({
  accountRef,
  tariffCode,
  chartType,
  usageType,
}: UseTariffSummaryCumulativeUsageDataProps) => {
  const { t } = useTranslation();
  const { data } = useSuspenseQuery<
    Awaited<ReturnType<typeof getTariffSummaryCumulativeUsage>>,
    Error,
    MappedUsageData
  >({
    queryKey: tariffSummaryGraphsQueries.cumulativeUsage({
      accountRef,
      tariffCode,
      chartType,
      usageType,
    }),
    queryFn: () =>
      setMinimalPromiseTime(
        getTariffSummaryCumulativeUsage({ accountRef, tariffCode, chartType, usageType }),
      ),
    select: (data) => mapUsageDTOtoAreaChartData(data, usageType, t),
  });

  return data;
};
